import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();

    // Filter the items based on the search text
    const filteredItems = items.filter(item =>
      item.Item_Text?.toLowerCase().includes(searchText)
    );

    // Add parent metrics for filtered items
    const result = [...filteredItems];

    filteredItems.forEach(filteredItem => {
      if (filteredItem.parentMetric) {
        const parent = items.find(item => item.lineItem === filteredItem.parentMetric);
        if (parent && !result.includes(parent)) {
          result.push(parent);
        }
      }
    });
    result.sort((a, b) => a.Metric_Order - b.Metric_Order);


    return result;
  }
}
